import app from 'flarum/forum/app';
import Hero from 'flarum/forum/components/Hero';
import Icon from 'flarum/common/components/Icon';
import ItemList from 'flarum/common/utils/ItemList';
export default class PollPageHero extends Hero {
  className() {
    return 'PollPageHero';
  }
  bodyItems() {
    const items = new ItemList();
    const title = this.attrs.title || app.translator.trans('fof-polls.forum.polls_page.title');
    const icon = this.attrs.icon || 'fas fa-poll';
    items.add('title', m("h2", {
      className: "Hero-title"
    }, [m(Icon, {
      name: icon
    }), ' ', title]), 100);
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/PollPageHero', PollPageHero);